import { render, staticRenderFns } from "./HRBook.vue?vue&type=template&id=71a3d18a&scoped=true"
import script from "./HRBook.vue?vue&type=script&lang=js"
export * from "./HRBook.vue?vue&type=script&lang=js"
import style0 from "./HRBook.vue?vue&type=style&index=0&id=71a3d18a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3d18a",
  null
  
)

export default component.exports